export const CLOTHES_CHANGER_STYLE_LIST = [
    {
        categoryName: 'men-shirts',
        list: [
            {
                name: 'men-shirts-01',
                img: 'men-shirts-01.png',
            },
            {
                name: 'men-shirts-02',
                img: 'men-shirts-02.png',
            },
            {
                name: 'men-shirts-03',
                img: 'men-shirts-03.png',
            },
            {
                name: 'men-shirts-04',
                img: 'men-shirts-04.png',
            },
            {
                name: 'men-shirts-05',
                img: 'men-shirts-05.png',
            },
            {
                name: 'men-shirts-06',
                img: 'men-shirts-06.png',
            },
            {
                name: 'men-shirts-07',
                img: 'men-shirts-07.png',
            },
            {
                name: 'men-shirts-08',
                img: 'men-shirts-08.png',
            },
            {
                name: 'men-shirts-09',
                img: 'men-shirts-09.png',
            },
        ],
    },
    {
        categoryName: 'women-shirts',
        list: [
            {
                name: 'women-shirts-01',
                img: 'women-shirts-01.png',
            },
            {
                name: 'women-shirts-02',
                img: 'women-shirts-02.png',
            },
            {
                name: 'women-shirts-03',
                img: 'women-shirts-03.png',
            },
            {
                name: 'women-shirts-04',
                img: 'women-shirts-04.png',
            },
            {
                name: 'women-shirts-05',
                img: 'women-shirts-05.png',
            },
            {
                name: 'women-shirts-06',
                img: 'women-shirts-06.png',
            },
            {
                name: 'women-shirts-07',
                img: 'women-shirts-07.png',
            },
        ],
    },
    {
        categoryName: 'mens-suits',
        list: [
            {
                name: 'men-suits-01',
                img: 'men-suits-01.png',
            },
            {
                name: 'men-suits-02',
                img: 'men-suits-02.png',
            },
            {
                name: 'men-suits-03',
                img: 'men-suits-03.png',
            },
            {
                name: 'men-suits-04',
                img: 'men-suits-04.png',
            },
            {
                name: 'men-suits-05',
                img: 'men-suits-05.png',
            },
            {
                name: 'men-suits-06',
                img: 'men-suits-06.png',
            },
            {
                name: 'men-suits-07',
                img: 'men-suits-07.png',
            },
            {
                name: 'men-suits-08',
                img: 'men-suits-08.png',
            },
        ],
    },
    {
        categoryName: 'women-suits',
        list: [
            {
                name: 'women-formal-wear-01',
                img: 'women-formal-wear-01.png',
            },
            {
                name: 'women-formal-wear-02',
                img: 'women-formal-wear-02.png',
            },
            {
                name: 'women-formal-wear-03',
                img: 'women-formal-wear-03.png',
            },
            {
                name: 'women-formal-wear-04',
                img: 'women-formal-wear-04.png',
            },
            {
                name: 'women-formal-wear-05',
                img: 'women-formal-wear-05.png',
            },
            {
                name: 'women-formal-wear-06',
                img: 'women-formal-wear-06.png',
            },
            {
                name: 'women-formal-wear-07',
                img: 'women-formal-wear-07.png',
            },
            {
                name: 'women-formal-wear-08',
                img: 'women-formal-wear-08.png',
            },
        ],
    },
    {
        categoryName: 'men-pants',
        list: [
            {
                name: 'cargo-pants',
                img: 'cargo-pants.png',
            },
            {
                name: 'color-block-sweatpants',
                img: 'color-block-sweatpants.png',
            },
            {
                name: 'dress-pants',
                img: 'dress-pants.png',
            },
            {
                name: 'jogger-pants',
                img: 'jogger-pants.png',
            },
            {
                name: 'knit-wool-trousers',
                img: 'knit-wool-trousers.png',
            },
            {
                name: 'leather-pants',
                img: 'leather-pants.png',
            },
            {
                name: 'straight-leg-jeans',
                img: 'straight-leg-jeans.png',
            },
            {
                name: 'techwear-pants',
                img: 'techwear-pants.png',
            },
        ],
    },
    {
        categoryName: 'women-pants',
        list: [
            {
                name: 'a-line-skirt',
                img: 'a-line-skirt.png',
            },
            {
                name: 'casual-wide-leg-pants',
                img: 'casual-wide-leg-pants.png',
            },
            {
                name: 'floor-length-maxi-skirt',
                img: 'floor-length-maxi-skirt.png',
            },
            {
                name: 'layered-skirt',
                img: 'layered-skirt.png',
            },
            {
                name: 'skinny-jeans',
                img: 'skinny-jeans.png',
            },
            {
                name: 'slim-flared-pants',
                img: 'slim-flared-pants.png',
            },
            {
                name: 'slim-tailored-trousers',
                img: 'slim-tailored-trousers.png',
            },
            {
                name: 'wool-knit-pants',
                img: 'wool-knit-pants.png',
            },
        ],
    },
    {
        categoryName: 'suits',
        list: [
            {
                name: 'chinese-style-set',
                img: 'chinese-style-set.png',
            },
            {
                name: 'denim-set',
                img: 'denim-set.png',
            },
            {
                name: 'floral-dress',
                img: 'floral-dress.png',
            },
            {
                name: 'french-tea-dress',
                img: 'french-tea-dress.png',
            },
            {
                name: 'racing-suit-set',
                img: 'racing-suit-set.png',
            },
            {
                name: 'sportswear-set',
                img: 'sportswear-set.png',
            },
            {
                name: 'suit-set',
                img: 'suit-set.png',
            },
            {
                name: 'workwear-set',
                img: 'workwear-set.png',
            },
        ],
    },
    {
        categoryName: 'men-others',
        list: [
            {
                name: 'hoodies-01',
                img: 'hoodies-01.png',
            },
            {
                name: 'hoodies-02',
                img: 'hoodies-02.png',
            },
            {
                name: 'jacket',
                img: 'jacket.png',
            },
            {
                name: 'leather-clothing',
                img: 'leather-clothing.png',
            },
            {
                name: 'polo-shirt-01',
                img: 'polo-shirt-01.png',
            },
            {
                name: 'polo-shirt-02',
                img: 'polo-shirt-02.png',
            },
            {
                name: 'pullover-sweaters-01',
                img: 'pullover-sweaters-01.png',
            },
            {
                name: 'pullover-sweaters-02',
                img: 'pullover-sweaters-02.png',
            },
            {
                name: 'sports-top-01',
                img: 'sports-top-01.png',
            },
            {
                name: 'sports-top-02',
                img: 'sports-top-02.png',
            },
            {
                name: 'sweatshirts-01',
                img: 'sweatshirts-01.png',
            },
            {
                name: 'sweatshirts-02',
                img: 'sweatshirts-02.png',
            },
            {
                name: 'tank-top-01',
                img: 'tank-top-01.png',
            },
            {
                name: 'tank-top-02',
                img: 'tank-top-02.png',
            },
            {
                name: 'tee-01',
                img: 'tee-01.png',
            },
            {
                name: 'tee-02',
                img: 'tee-02.png',
            },
        ],
    },
    {
        categoryName: 'women-others',
        list: [
            {
                name: 'womens-hoodies-01',
                img: 'womens-hoodies-01.png',
            },
            {
                name: 'womens-hoodies-02',
                img: 'womens-hoodies-02.png',
            },
            {
                name: 'womens-hoodies-03',
                img: 'womens-hoodies-03.png',
            },
            {
                name: 'womens-jacket',
                img: 'womens-jacket.png',
            },
            {
                name: 'womens-leather-clothing',
                img: 'womens-leather-clothing.png',
            },
            {
                name: 'womens-pullover-sweaters-01',
                img: 'womens-pullover-sweaters-01.png',
            },
            {
                name: 'womens-pullover-sweaters-02',
                img: 'womens-pullover-sweaters-02.png',
            },
            {
                name: 'womens-sports-top-01',
                img: 'womens-sports-top-01.png',
            },
            {
                name: 'womens-sports-top-02',
                img: 'womens-sports-top-02.png',
            },
            {
                name: 'womens-sports-top-03',
                img: 'womens-sports-top-03.png',
            },
            {
                name: 'womens-sweatshirts-01',
                img: 'womens-sweatshirts-01.png',
            },
            {
                name: 'womens-sweatshirts-02',
                img: 'womens-sweatshirts-02.png',
            },
            {
                name: 'womens-sweatshirts-03',
                img: 'womens-sweatshirts-03.png',
            },
            {
                name: 'womens-tee-01',
                img: 'womens-tee-01.png',
            },
            {
                name: 'womens-tee-02',
                img: 'womens-tee-02.png',
            },
        ],
    },
];
